module.exports = "\r\n              <navbar-cmp></navbar-cmp>\r\n              <app-sidebar></app-sidebar>\r\n              <router-outlet></router-outlet>\r\n\r\n   "


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main